export const Bio = {
  name: "Vihidun",
  roles: [
    "Software Engineer"
  ],
  description: "",
  github: "https://github.com/tharoosha",
  resume:
    "https://drive.google.com/file/d/1xOox4b8IbuIunX4HdIzCFzsAcdygxZDb/view?usp=drive_link",
  linkedin: "https://www.linkedin.com/in/vihidundpt/",
  twitter: "https://x.com/RuSavihidun",
  medium: "https://medium.com/@tharooshavihidun",
};

export const skills = [
 
  {
    title: "Machine Learning",
    skills: [
      {
        name: "Python",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        name: "Pytorch",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSKcMdnLnVtxso40OlPI63YHziAlg_34FVbIA&s",
      },
      {
        name: "Keras",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/a/ae/Keras_logo.svg/1200px-Keras_logo.svg.png",
      },
      {
        name: "Jupyter",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/3/38/Jupyter_logo.svg/1767px-Jupyter_logo.svg.png",
      },
      {
        name: "Google Colab",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSr3rVUaAQm-cX9raE8hDgrM58Xy6DH25tkNw&s",
      },
      {
        name: "GeminiAI",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcThr7qrIazsvZwJuw-uZCtLzIjaAyVW_ZrlEQ&s",
      },
      {
        name: "OpenAI",
        image: "https://cdn.prod.website-files.com/5f6bc60e665f54db361e52a9/65fde68748ee62e29dcf7a4e_logo-openai.svg"
      },
      {
        name: "MistralAI",
        image:"https://avatars.githubusercontent.com/u/132372032?s=200&v=4"
      },
      {
        name: "CrewAI",
        image:"https://avatars.githubusercontent.com/u/170677839?v=4"
      },
      {
        name: "LangGraph",
        image:"https://pbs.twimg.com/profile_images/1758141568970878976/fM5FlvD3_200x200.jpg"
      },
      {
        name: "LangChain",
        image:"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQShzFsCcn2XFanVgk0xiEgPGicINuEgO2ADw&s"
      },
      {
        name: "PhiData",
        image:"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT20wNoE6qnK8EElAGyVt70XgkSANx4Gc80Hw&s"
      },
      {
        name: "Kaggle",
        image:"https://pbs.twimg.com/profile_images/1573129499343978498/03a7wgfE_400x400.jpg"
      },
      {
        name: "OpenCV",
        image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQfRklXyWQy1ditXPl8oBPdbcdjxuiVU3Z3VA&s"
      },
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Node Js",
        image: "https://nodejs.org/static/images/logo.svg",
      },
      {
        name: "SpringBoot",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT8i4zPog-0j0JR_yZglxPhTPZXxN2iMTQ3Dw&s",
      },
      // {
      //   name: "Graph Ql",
      //   image: "https://www.vectorlogo.zone/logos/graphql/graphql-icon.svg",
      // },
      {
        name: "Python",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        name: "Java",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
      },
      {
        name: "Flask",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS_bhcLW99kCp6YmuOQYI2cG2IhrIsFW9bb4Q&s",
      },
      {
        name: "FastAPI",
        image:
          "https://w7.pngwing.com/pngs/211/216/png-transparent-fastapi-hd-logo.png",
      },
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "Postgresql",
        image: "https://www.postgresql.org/media/img/about/press/elephant.png",
      },
      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
      {
        name: "ChromaDB",
        image: "https://www.trychroma.com/_next/static/media/chroma.d840f629.png"
      },
      {
        name: "Neo4J",
        image: "https://store-images.s-microsoft.com/image/apps.29245.a11ad18d-23ee-4629-bb5a-88dda5d3c2d9.34868e88-e127-48d9-83eb-bdb70ddc5795.6521a2f5-62f1-4630-9e02-0dac33326d13",
      },
      {
        name: "NiFi",
        image: "https://pbs.twimg.com/profile_images/763114082643738624/qpL7Veso_400x400.jpg"
      },
    ],
  },
  {
    title: "DevOps",
    skills: [
      {
        name: "AWS",
        image:
          "https://download.logo.wine/logo/Amazon_Web_Services/Amazon_Web_Services-Logo.wine.png",
      },
      // {
      //   name: "Google Cloud",
      //   image:
      //     "https://static-00.iconduck.com/assets.00/google-cloud-platform-logo-icon-2048x1824-pg4wzspq.png",
      // },
      {
        name: "Docker",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/docker/docker-original-wordmark.svg",
      },
      // {
      //   name: "Jenkins",
      //   image:
      //     "https://toppng.com/uploads/preview/jenkins-logo-11609365847mufysaivph.png",
      // },
      // {
      //   name: "Nginx",
      //   image: "https://download.logo.wine/logo/Nginx/Nginx-Logo.wine.png",
      // },
      // {
      //   name: "Grafana",
      //   image:
      //     "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a1/Grafana_logo.svg/1200px-Grafana_logo.svg.png",
      // },
      {
        name: "Kubernetes",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/0/00/Kubernetes_%28container_engine%29.png",
      },
      // {
      //   name: "Prometheus",
      //   image:
      //     "https://upload.wikimedia.org/wikipedia/commons/thumb/3/38/Prometheus_software_logo.svg/1200px-Prometheus_software_logo.svg.png",
      // },
    ],
  },
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "Angular Js",
        image:
          "https://miro.medium.com/v2/resize:fit:588/1*15CYVZdpsxir8KLdxEZytg.png",
      },
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },



    ],
  },
  // {
  //   title: "Android",
  //   skills: [
  //     {
  //       name: "Java",
  //       image:
  //         "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
  //     },
  //     {
  //       name: "Kotlin",
  //       image:
  //         "https://www.vectorlogo.zone/logos/kotlinlang/kotlinlang-icon.svg",
  //     },
  //     {
  //       name: "Jetpack Compose",
  //       image:
  //         "https://3.bp.blogspot.com/-VVp3WvJvl84/X0Vu6EjYqDI/AAAAAAAAPjU/ZOMKiUlgfg8ok8DY8Hc-ocOvGdB0z86AgCLcBGAsYHQ/s1600/jetpack%2Bcompose%2Bicon_RGB.png",
  //     },
  //     {
  //       name: "XML",
  //       image:
  //         "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSBMw6_RdwKQ9bDFfnKDX1iwMl4bVJEvd9PP53XuIw&s",
  //     },
  //     {
  //       name: "Android Studio",
  //       image:
  //         "https://developer.android.com/static/studio/images/new-studio-logo-1_1920.png",
  //     },
  //   ],
  // },

  {
    title: "Others",
    skills: [
      {
        name: "Git",
        image:
          "https://e7.pngegg.com/pngimages/713/558/png-clipart-computer-icons-pro-git-github-logo-text-logo-thumbnail.png",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      // {
      //   name: "Netlify",
      //   image:
      //     "https://seeklogo.com/images/N/netlify-logo-BD8F8A77E2-seeklogo.com.png",
      // },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      {
        name: "Postman",
        image:
          "https://static-00.iconduck.com/assets.00/postman-icon-497x512-beb7sy75.png",
      },
      // {
      //   name: "Adobe XD",
      //   image:
      //     "https://camo.githubusercontent.com/c205ecbe12500177d102169d97bc1c17c545155fdf5ec78c08d54ac53e5b38c1/68747470733a2f2f63646e2e776f726c64766563746f726c6f676f2e636f6d2f6c6f676f732f61646f62652d78642e737667",
      // },
      {
        name: "Figma",
        image:
          "https://s3-alpha.figma.com/hub/file/1481185752/fa4cd070-6a79-4e1b-b079-8b9b76408595-cover.png",
      },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: "https://media.licdn.com/dms/image/v2/D560BAQFHt9AOKQ1X8w/company-logo_200_200/company-logo_200_200/0/1730260448003/99xio_logo?e=2147483647&v=beta&t=--IFGC9VNy5IG0LSoi0-nRC77spIVHjWlJrspvgEtgc",
    role: "Software Engineer",
    company: "99x.io",
    date: "July 2025 - Present",
    desc: "Working as a Software Engineer at 99x.io, contributing to product engineering initiatives using the Microsoft technology stack. Involved in building and maintaining scalable software solutions with .NET and Aurelia on Azure cloud infrastructure, collaborating within agile teams to deliver high-quality software products.",
    skills: [
      ".NET",
      "Aurelia",
      "Azure",
      "Microsoft"
    ],
  },
  {
    id: 1,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRE7TToIuaBtDhfAOq3HeQKpilGgVvqs-rp7Q&s",
    role: "Software Engineer & Researcher",
    company: "Donely AI",
    date: "April 2025 - Sep 2025",
    desc: "Contributed as a Software Engineer and Researcher to design and develop the first phase of a computer-use multi-agent platform that natively operates on desktop environments. The platform leverages agentic AI to autonomously interact with installed applications and web browsers on behalf of users — executing real-world tasks through human-like computer interaction. Worked on agent orchestration, task planning pipelines, and system-level integration to enable seamless end-to-end automation across diverse software environments.",
    skills: [
      "LangGraph",
      "LangChain",
      "Computer Use Agents",
      "Python",
      "Electron",
      "AWS"
    ],
  },
  {
    id: 2,
    img: "https://media.licdn.com/dms/image/v2/C560BAQE9-4bSDMJ8mg/company-logo_200_200/company-logo_200_200/0/1631153821451/axiatadigitallabsatthelab_logo?e=2147483647&v=beta&t=xaotu-W9_bphCTJwBy2k14yevsOh47mvXnpVWR5dAQc",
    role: "Data Science Intern",
    company: "Axiata Digital Labs",
    date: "Nov 2023 - Jul 2024",
    desc: "Contributed to “Mighty Minions: Unleashing Domain-Specific GenAI via SLMs” by developing solutions, and API specifications for TM-Forum Open API and co-authoring the related white paper. Delivered a detailed analysis of customer feedback patterns to business partners during high-stakes discussions, leading to the reallocation of resources and improved overall customer engagement Developed Integrated social media comment analysis solutions, call center SOP assistance and revenue data analysis leveraging GenAI.",
    skills: [
      "SLMs",
      "LangChain",
      "Kubernetes",
      "SQLite",
      "Python",
      "PyTorch",
      "Neo4J",
    ],
    // doc: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/Screenshot%20from%202024-01-25%2022-38-31.png?alt=media&token=2785903f-1a4e-41f5-afd2-6adcfe56d058",
  },
  {
    id: 3,
    img: "https://avatars.githubusercontent.com/u/168341676?s=280&v=4",
    role: "Backend & ML Engineer Freelance",
    company: "WeYora (Pvt)Ltd",
    date: "Jul 2024 - Dec 2024",
    desc: "Developed client solutions using GenAI, AI, and ML, with backend implementation in FastAPI and Flask, and containerized with Docker.",
    skills: [
      "Docker",
      "AWS",
      "EC2",
      "Python",
      "LLMs",
    ],
    // doc: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/1696514649120.jpeg?alt=media&token=e7f6757b-edfa-4138-a692-d6709eeef3e2",
  },
  // {
  //   id: 2,
  //   img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/Rudraksha.jpeg?alt=media&token=8f83f41e-d0a1-486f-9c7f-dd4cd1d09e8d",
  //   role: "Android Developer Intern",
  //   company: "Rudraksha Welffare Foundation",
  //   date: "June 2021 - Oct 2021",
  //   desc: "• Built RudraShakti - Astrologer App, with MVVM Architecture using Java and Android Studio integrating Firebase SDK. Created One to One video call integration with Socket.IO and Firebase cloud functions and integrated with Retrofit. Created Low Level Design and converted Figma design to XML code.",
  //   skills: [
  //     "Android",
  //     "Java",
  //     "Kotlin",
  //     "XML",
  //     "Node Js",
  //     "Cloud Firestore",
  //     "Firebase",
  //     "Figma",
  //   ],
  //   doc: "https://firebasestorage.googleapis.com/v0/b/buckoid-917cf.appspot.com/o/WhatsApp%20Image%202023-05-05%20at%2012.07.39%20AM.jpeg?alt=media&token=9f0e1648-568b-422d-bd0b-1f125f722245",
  // },
  // {
  //   id: 3,
  //   img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/flipr.jpeg?alt=media&token=1d72532a-45eb-4c1a-a81a-c9bed9fec543",
  //   role: "Fullstack Externship",
  //   company: "Flipr",
  //   date: "June 2023 - July 2023",
  //   desc: "Built an employee management full stack web app used Docker and deployed on AWS ec2. I was the top performer in the program.",
  //   skills: [
  //     "ReactJS",
  //     "Redux",
  //     "NodeJs",
  //     "Material UI",
  //     "HTML",
  //     "CSS",
  //     "JavaScript",
  //     "Docker",
  //     "AWS",
  //     "MongoDB",
  //   ],
  //   doc: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/1691181448873.jpeg?alt=media&token=ee85eb8f-7247-43cd-9a1d-ce9f58ea62a6",
  // },
  // {
  //   id: 4,
  //   img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/gdsc.jpeg?alt=media&token=c162329c-efaa-4be8-a173-8d3f4c48ea70",
  //   role: "Android Developer",
  //   company: "DSC KIIT",
  //   date: "Nov2021 - Present",
  //   desc: "As an Android developer at the Google Developers Student Club (GDCS), I have had the opportunity to work on exciting projects and collaborate with talented developers who share my passion for technology. Through my involvement with GDCS, I have also had the opportunity to host and participate in numerous events, including hackathons, study jams, and workshops.",
  //   skills: [
  //     "Leadership",
  //     "Mobile Application Development",
  //     "Kotlin",
  //     "XML",
  //     "Figma",
  //   ],
  // },
  // {
  //   id: 5,
  //   img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/girlScript.jpeg?alt=media&token=e656a621-cf3c-4230-bf0f-e74b4cec6035",
  //   role: "Open Source Contributor ",
  //   company: "GirlScript Summer of Code",
  //   date: "May 2023 - Present",
  //   desc: "Contributed to different open-source projects and learn from industry experts",
  // },
];

export const education = [
  {
    id: 0,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQB94CkjZvDkNJrit3zvXXkDAoWGrvlr1sNHw&s",
    school: "University of Moratuwa, Sri Lanka",
    date: "Jul 2021 - Jul 2025",
    grade: " GPA 3.48/4.00 (Second Upper)",
    desc: "I completed Bachelor's degree in Computer Science and Engineering at the University of Moratuwa, with a specialization in Data Science and Engineering.",
    degree: "BSc Eng Hons, Computer Science & Engineering specializing in Data Science and Engineering",
  },
  {
    id: 1,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSQtV4vBYDJFaCAw30-aupjjcnPeiMbHMC1uw&s",
    school: "Central Collage Anuradhapura, Sri Lanka",
    date: "2016 - 2019",
    grade: " 3A's",
    desc: "I completed advance level education at Central Collage Anuradhapura, Sri Lanka, where I studied Mathematics, Physics, & Chemistry.",
    degree: "General Certificate of Education (Advance Level)",
  },
  {
    id: 2,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSQtV4vBYDJFaCAw30-aupjjcnPeiMbHMC1uw&s",
    school: "Central Collage Anuradhapura, Sri Lanka",
    date: "2006 - 2016",
    grade: " 9A's",
    desc: "I completed my ordinary education at Central Collage Anuradhapura, Sri Lanka, where I studied Science, Mathematics, Information Technology and other 6 modules.",
    degree: "General Certificate of Education (Ordinary Level)",
  },
];

// export const projects = [
//   {
//     id: 11,
//     title: "LAAI - Learner Aware AI Agent",
//     date: "May 2024 - Present",
//     description:
//       "Final year research project developing personalized tutoring agent with adaptive learning and student modelling to boost student engagement in MOOCs (Massive open online courses) and online learning through Socratic tutoring and knowledge tracing, utilizing open-source PLMs and the Agentic framework.",
//     image:
//       "https://i.pinimg.com/736x/61/8a/22/618a22732758af6cb12c43283b689e72.jpg",
//     tags: [
//       "Python", "Pytorch", "Gemini", "CrewAI", "React", "FastAPI", "SQLite",
//     ],
//     category: "machine learning",
//     github: "https://github.com/Learn-Aware/learnaware-ai.git",
//     // webapp: "https://decisionhub.netlify.app/",
//     member: [
//       {
//         name: "Pasindu Malshan Keerthichandra",
//         img: "https://media.licdn.com/dms/image/v2/D5603AQFHsAjwVbxWDA/profile-displayphoto-shrink_400_400/profile-displayphoto-shrink_400_400/0/1727458680750?e=1742428800&v=beta&t=DWH-pF8RxMWpxQbtpE_6_7xxroNdUj3J7_nSq693ZhY",
//         // linkedin: "https://www.linkedin.com/in/rishav-chanda-b89a791b3/",
//         // github: "https://github.com/malshanCS",
//       },
//       {
//         name: "Shanuka Lakshan",
//         img: "https://media.licdn.com/dms/image/v2/D5635AQElNVTdp2xWDA/profile-framedphoto-shrink_800_800/profile-framedphoto-shrink_800_800/0/1734505237716?e=1737309600&v=beta&t=Ud9sj0Qk7Wj04K8S2ZdpzE-MLa8EHn2weaPgSdVfwX4",
//         // linkedin: "https://www.linkedin.com/in/upasana-chaudhuri-2a2bb5231/",
//         // github: "https://github.com/upasana0710",
//       },
//     ],
//   },
//   {
//     id: 9,
//     title: "Reflex - Next Generation Shopping Platform with Custobots",
//     date: "Dec 2024 - Present",
//     description:
//       "Next-Generation E-Commerce Application powered by Agentic AI, featuring a recommendation system, data analysis (time series, correlation analysis, predictive modeling), shopping agent, payment agent, and more.",
//     image:
//       "https://raw.githubusercontent.com/tharoosha/Reflex/refs/heads/main/Screenshot%202025-01-12%20at%2010.38.49%E2%80%AFPM.png",
//     tags: [
//       "Python", "ReactNative", "PhiData", "CrewAI", "Weaviate",
//     ],
//     category: "machine learning",
//     github: "https://github.com/tharoosha/Reflex.git",
//     // webapp: "https://trackify-management.netlify.app/",
//     member: [
//       {
//         name: "Imalsha Puneregedara",
//         img: "https://media.licdn.com/dms/image/v2/D5603AQGEWElbkrgOhA/profile-displayphoto-shrink_400_400/B56ZOuqDHoG8Ag-/0/1733802079260?e=1742428800&v=beta&t=f1IY1TPRo6WVrfjQHHS2jt2KJcXylHF0PQFyH4N0mEM",
//         // linkedin: "https://www.linkedin.com/in/rishav-chanda-b89a791b3/",
//         // github: "https://github.com/malshanCS",
//       },
//       {
//         name: "Indunil Umayanga",
//         img: "https://media.licdn.com/dms/image/v2/D5635AQHV_prrvsxWmA/profile-framedphoto-shrink_400_400/profile-framedphoto-shrink_400_400/0/1718261527439?e=1737309600&v=beta&t=AonlNi4x5FswhEjsu1ZOjcyhhrpQsfOeqGv3jBl4uqg",
//         // linkedin: "https://www.linkedin.com/in/upasana-chaudhuri-2a2bb5231/",
//         // github: "https://github.com/upasana0710",
//       },
//       {
//         name: "Sheshan Premathilaka",
//         img: "https://media.licdn.com/dms/image/v2/C5603AQHbn73lE8DDKw/profile-displayphoto-shrink_800_800/profile-displayphoto-shrink_800_800/0/1663517175311?e=1742428800&v=beta&t=uf0rPN-XxIve6vJTU5Q-Xw3Ul3HhmvE0yGcYQdDrdaI",
//         // linkedin: "https://www.linkedin.com/in/upasana-chaudhuri-2a2bb5231/",
//         // github: "https://github.com/upasana0710",
//       },
//       {
//         name: "Shehan Premathilaka",
//         img: "https://media.licdn.com/dms/image/v2/D5603AQHRSHE5AtqHvw/profile-displayphoto-shrink_800_800/profile-displayphoto-shrink_800_800/0/1663512681611?e=1742428800&v=beta&t=G3L3hUojvW5r9VX0-D5bG4IHf-g3lNycLvzp9skXSJY",
//         // linkedin: "https://www.linkedin.com/in/upasana-chaudhuri-2a2bb5231/",
//         // github: "https://github.com/upasana0710",
//       },
//     ],
//   },
//   // {
//   //   id: 0,
//   //   title: "Podstream",
//   //   date: "Apr 2023 - May 2023",
//   //   description:
//   //     "Developed a full-stack web application that allows users to search for, play, and pause their favorite podcasts on demand and create podcasts. Implemented user authentication using Google Auth and Jwt Auth, made responsive user interface with React JS that provides users with a seamless experience across all devices. Practiced agile methodologies to optimize team efficiency and communication.",
//   //   image:
//   //     "https://user-images.githubusercontent.com/64485885/234602896-a1bd8bcc-b72b-4821-83d6-8ad885bf435e.png",
//   //   tags: ["React Js", "MongoDb", "Node Js", "Express Js", "Redux"],
//   //   category: "web app",
//   //   github: "https://github.com/rishavchanda/Podstream",
//   //   webapp: "https://podstream.netlify.app/",
//   //   member: [
//   //     {
//   //       name: "Rishav Chanda",
//   //       img: "https://avatars.githubusercontent.com/u/64485885?v=4",
//   //       linkedin: "https://www.linkedin.com/in/rishav-chanda-b89a791b3/",
//   //       github: "https://github.com/rishavchanda/",
//   //     },
//   //     {
//   //       name: "Upasana Chaudhuri",
//   //       img: "https://avatars.githubusercontent.com/u/100614635?v=4",
//   //       linkedin: "https://www.linkedin.com/in/upasana-chaudhuri-2a2bb5231/",
//   //       github: "https://github.com/upasana0710",
//   //     },
//   //   ],
//   // },
//   // {
//   //   id: 1,
//   //   title: "Vexa",
//   //   date: "Oct 2022 - Jan 2023",
//   //   description:
//   //     "Designed and developed the Vexa project, a project management app that helps users and teams stay organized and on track. Implemented key features such as task tracking, team collaboration, and time tracking to improve productivity and project outcomes and also invite team/project members. The plan is to add a community of users where they can find developers and other team members and chat system implementation.",
//   //   image:
//   //     "https://user-images.githubusercontent.com/64485885/234916413-96296f13-fe4b-4cc4-b215-e72bd7c27928.png",
//   //   tags: [
//   //     "React Js",
//   //     "MongoDb",
//   //     "Node Js",
//   //     "Express Js",
//   //     "Redux",
//   //     "NodeMailer",
//   //   ],
//   //   category: "web app",
//   //   github: "https://github.com/rishavchanda/Project-Management-App",
//   //   webapp: "https://vexa-app.netlify.app/",
//   // },
//   // {
//   //   id: 2,
//   //   title: "Brain Tumor Detection",
//   //   date: "Jan 2023 - Mar 2023",
//   //   description:
//   //     "Preprocessed and augmented the dataset to improve model accuracy, trained the model, created API using model and Python, and used React web app for the project's front end. Achievements: Achieved an accuracy of 99.2% to accurately detect brain tumors from medical images.",
//   //   image:
//   //     "https://github.com/rishavchanda/Brain-Tumor-Detection/raw/main/Readme_resource/Image2.png",
//   //   tags: ["Python", "Keras", "TensorFlow", "VGG16", "Pickle", "React"],
//   //   category: "machine learning",
//   //   github: "https://github.com/rishavchanda/Brain-Tumor-Detection",
//   //   webapp: "https://brain-tumor.netlify.app/",
//   //   member: [
//   //     {
//   //       name: "Rishav Chanda",
//   //       img: "https://avatars.githubusercontent.com/u/64485885?v=4",
//   //       linkedin: "https://www.linkedin.com/in/rishav-chanda-b89a791b3/",
//   //       github: "https://github.com/rishavchanda/",
//   //     },
//   //     {
//   //       name: "Upasana Chaudhuri",
//   //       img: "https://avatars.githubusercontent.com/u/100614635?v=4",
//   //       linkedin: "https://www.linkedin.com/in/upasana-chaudhuri-2a2bb5231/",
//   //       github: "https://github.com/upasana0710",
//   //     },
//   //   ],
//   // },
//   // {
//   //   id: 3,
//   //   title: "Buckoid",
//   //   date: "Dec 2021 - Apr 2022",
//   //   description:
//   //     "App Is Currently In Playstore 100+ Downloads. This Project proposes an “Expense Tracking App”. Keep track of your personal expenses and compare them to your monthly income with the budget planner. It has Google Drive Cloud API for Backup of User Room Database. Made with Kotlin in MVVM Architecture & Live Data.",
//   //   image:
//   //     "https://camo.githubusercontent.com/3ad28aa710d18525f1fc87de056ed53c706d09979589bfd5a773df36653bad38/68747470733a2f2f666972656261736573746f726167652e676f6f676c65617069732e636f6d2f76302f622f6c6f67696e2d65613565322e61707073706f742e636f6d2f6f2f4255434b4f49442532302831292e706e673f616c743d6d6564696126746f6b656e3d32653735376235372d323964372d346263612d613562322d653164346538313432373435",
//   //   tags: ["Kotlin", "MVVM", "Room Database", "Google Drive Cloud API"],
//   //   category: "android app",
//   //   github: "https://github.com/rishavchanda/Buckoid-Android-App",
//   //   webapp: "https://play.google.com/store/apps/details?id=com.rishav.buckoid",
//   // },
//   // {
//   //   id: 10,
//   //   title: "Job Finding App",
//   //   date: "Jun 2023 - Jul 2023",
//   //   description:
//   //     "A Job Finding App made with React Native, Axios. Users can search for any job coming from API and apply there.",
//   //   image:
//   //     "https://user-images.githubusercontent.com/64485885/255237090-cf798a2c-1b41-4bb7-b904-b5353a1f08e8.png",
//   //   tags: ["React Native", "JavaScript", "Axios"],
//   //   category: "android app",
//   //   github: "https://github.com/rishavchanda/Job-finder-App",
//   //   webapp: "https://github.com/rishavchanda/Job-finder-App",
//   // },
//   // {
//   //   id: 4,
//   //   title: "Whatsapp Clone",
//   //   date: "Jul 2021",
//   //   description:
//   //     "A WhatsApp clone made with React JS, Firebase, and Material UI. It has Phone Authentication, Real-time Database. It has a chat room where users can chat with each other. It has a sidebar where users can see all the chat rooms and can create a new chat room. It has a login page where users can log in with their Google account.",
//   //   image:
//   //     "https://firebasestorage.googleapis.com/v0/b/whatsapp-clone-rishav.appspot.com/o/Screenshot%20(151).png?alt=media&token=48391593-1ef0-4a8c-a92a-eb82bdf38e89",
//   //   tags: ["React Js", "Firebase", "Firestore", "Node JS"],
//   //   category: "web app",
//   //   github: "https://github.com/rishavchanda/Whatsapp-Clone-React-Js",
//   //   webapp: "https://whatsapp-clone-rishav.web.app",
//   // },
//   // {
//   //   id: 5,
//   //   title: "Todo Web App",
//   //   date: "Jun 2021",
//   //   description:
//   //     " A Todo Web App made with React JS, Redux, and Material UI. It has a login page where users can log in with their Google account. It has a sidebar where users can see all the tasks and can create a new task. It has a calendar where users can see all the tasks on a particular date. It has a search bar where users can search for a particular task.",
//   //   image:
//   //     "https://camo.githubusercontent.com/84ac6ab6f378348ef28d8184062b7e9e3511a1252ae3966eaa49e8e998f732a7/68747470733a2f2f666972656261736573746f726167652e676f6f676c65617069732e636f6d2f76302f622f746f646f2d6170702d63386331392e61707073706f742e636f6d2f6f2f53637265656e73686f74253230283938292e706e673f616c743d6d6564696126746f6b656e3d33643335646366322d626666322d343730382d393031632d343232383866383332386633",
//   //   tags: ["React Js", "Local Storage", "AWS Auth", "Node JS"],
//   //   category: "web app",
//   //   github: "https://github.com/rishavchanda/Todo-Web-App",
//   //   webapp: "https://rishav-react-todo.netlify.app/",
//   // },
//   // {
//   //   id: 6,
//   //   title: "Breaking Bad",
//   //   date: "Jun 2021",
//   //   description:
//   //     "A simple react app that shows the characters of the famous TV series Breaking Bad. It uses the Breaking Bad API to fetch the data. It also has a search bar to search for a particular character.",
//   //   image:
//   //     "https://camo.githubusercontent.com/937774368308a82419f53dd6eeb4a8675780e119636488b4e3cfe5d34859a72a/68747470733a2f2f666972656261736573746f726167652e676f6f676c65617069732e636f6d2f76302f622f746f646f2d6170702d63386331392e61707073706f742e636f6d2f6f2f53637265656e73686f7425323028313534292e706e673f616c743d6d6564696126746f6b656e3d65613439383630632d303435362d343333342d616435372d336239346663303333363263",
//   //   tags: ["React Js", "API", "Axios", "Node JS"],
//   //   category: "web app",
//   //   github: "https://github.com/rishavchanda/Breaking-Bad",
//   //   webapp: "https://breaking-bad-webapp.netlify.app",
//   // },
//   // {
//   //   id: 7,
//   //   title: "Quiz App",
//   //   date: "Dec 2020 - Jan 2021",
//   //   description:
//   //     "A android quiz app made with Java and Firebase. It has a login page where users can log in with their Google account. It has a sidebar where users can see all the quiz categories and can create a new quiz. It has a leaderboard where users can see the top 10 scorers. It has a search bar where users can search for a particular quiz.",
//   //   image:
//   //     "https://github-production-user-asset-6210df.s3.amazonaws.com/64485885/239726262-c1b061d1-d9d0-42ef-9f1c-0412d14bc4f6.gif",
//   //   tags: ["Java", "Android Studio", "Firebase", "Google Auth"],
//   //   category: "android app",
//   //   github: "https://github.com/rishavchanda/Quiz-Earn",
//   //   webapp: "https://github.com/rishavchanda/Quiz-Earn",
//   // },
//   // {
//   //   id: 8,
//   //   title: "Face Recognition",
//   //   date: "Jan 2021",
//   //   description:
//   //     "A Face recognition python app made with OpenCV. It uses face_recognition library to detect faces. It uses the webcam to detect faces. It also has a search bar to search for a particular face.",
//   //   image:
//   //     "https://dontrepeatyourself.org/media/face-recognition-with-python-dlib-and-deep-learning_cezKZBj.png",
//   //   tags: ["Python", "Keras", "TensorFlow", "VGG16", "Pickle", "React"],
//   //   category: "machine learning",
//   //   github: "https://github.com/rishavchanda/Face-Recodnition-AI-with-Python",
//   //   webapp: "https://github.com/rishavchanda/Face-Recodnition-AI-with-Python",
//   // },
// ];

